import topic from '../topic';
export const mstfAPI = {
  getMstfs: topic.mstfTopic + '/get_mstfs',
  stockOut: topic.mstfTopic + '/stock_out',
  stockIn: topic.mstfTopic + '/stock_in',
  stpr_stock_out: topic.mstfTopic + '/stpr_stock_out'
};
